module.exports = __webpack_public_path__ + "img/64.ac21b152.png";